import { render, staticRenderFns } from "./AgreementPriceChangeHistory.vue?vue&type=template&id=24b2b7d4&"
import script from "./AgreementPriceChangeHistory.vue?vue&type=script&lang=js&"
export * from "./AgreementPriceChangeHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports